import { render, staticRenderFns } from "./foodMenu.vue?vue&type=template&id=933688c2&scoped=true"
import script from "./foodMenu.vue?vue&type=script&lang=js"
export * from "./foodMenu.vue?vue&type=script&lang=js"
import style0 from "./foodMenu.vue?vue&type=style&index=0&id=933688c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933688c2",
  null
  
)

export default component.exports